import {Spinner} from "react-bootstrap";

/**
 * This is a simple component to display a loading screen
 */
export default function LoadingScreen() {
  return <div className={"content-area non-menu-page loading"}>
    <h1 className="mb-2">Loading</h1>
    <p className="text-muted mb-4">Please wait while we load your page. Thank you for your patience.</p>
    <Spinner animation="border" variant="primary"/>
  </div>
}